/**
 * @file navbar
 * @author wangzhuang
 */

import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {NavBar} from 'antd-mobile';
import './index.less';

const SAFE_ADVISORY = 'SAFE_ADVISORY';
class TopBar extends Component {
    static propTypes = {
        changeNavIndex: PropTypes.func,
        userInfo: PropTypes.object,
        productId: PropTypes.object,
        navList: PropTypes.array,
        history: PropTypes.object
    };

    constructor(...args) {
        super(...args);
        let res = this.isTest();
        this.state = {
            userShow: false,
            menuShow: false,
            isLogin: false,
            navIndex: [],
            navIndex2: [],
            extraIndex: [],
            isTest: res,
            loginUrl: this.loginUrl()
        };
    }

    componentDidMount() {
        this.setState({
            userShow: false
        });
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.history.location.pathname === '/'
            && this.props.history.location.pathname !== '/'
            && this.state.menuShow) {
            this.setState({menuShow: false, navIndex: [], navIndex2: []});
        }

        const {userInfo, productId, navList, changeNavIndex} = nextProps;
        let {navIndex, navIndex2} = this.state;
        if (!this.isEmptyobj(userInfo)) {
            this.setState({
                isLogin: userInfo.status === 0
            });
        }

        if (!this.isEmptyobj(productId) && navList) {
            let id = productId.id;
            navList.forEach((item, index) => {
                item.child.forEach((item2, index2) => {
                    if (item2.flag === 'page' && item2.alias === id) {
                        changeNavIndex(index);
                        navIndex[index] = true;
                        this.setState({
                            navIndex: navIndex
                        });
                    } else if (item2.flag === 'navigation') {
                        item2.child.forEach(item3 => {
                            if (item3.alias === id) {
                                changeNavIndex(index);
                                navIndex[index] = true;
                                navIndex2[index2] = true;
                                this.setState({
                                    navIndex: navIndex,
                                    navIndex2: navIndex2
                                });
                            }
                        });
                    }
                });
            });
        }

        if (navList !== this.props.navList && location.href.match('bug_search')) {
            this.setState({extraIndex: [SAFE_ADVISORY]});
        }
    }

    onMaskClick = () => {
        this.setState({
            userShow: false,
            menuShow: false
        });
    };

    changeLogin = () => {
        const {isLogin, loginUrl} = this.state;
        const params = this.getParams() || {};

        if (/\/haoma\/guide/.test(location.href) && params.url) {
            location.href = this.loginUrl(params.url);
            return;
        }
        if (isLogin) {
            location.href = `/user/logout?redirect_url=${encodeURIComponent(location.href)}`;
        } else {
            location.href = loginUrl;
        }
    };

    render() {
        let {userShow, menuShow, isLogin, navIndex, navIndex2, loginUrl, extraIndex} = this.state;
        const {userInfo, navList, productId} = this.props;
        const userEl = (
            <div className={'user-el'}>
                <div className={'single-foo-menu'}>
                    <a href={'/m/apply'} target={'_blank'}>业务咨询</a>
                    <a href={'/m/brand'}>百度安全品牌</a>
                    <a href={isLogin ? '/console/' : loginUrl}>控制台</a>
                </div>
                <div className={'user-info'}>
                    {
                        isLogin
                            ? <div className={'user-name'}>
                                {userInfo.data.user_name}
                            </div>
                            : ''
                    }

                    <div className={'login-btn'} onClick={this.changeLogin}>
                        {isLogin ? '退出' : '登录'}
                    </div>
                </div>
            </div>
        );

        const menuEl = (
            <div className={'menu-el-box'}>
                <ul className={'menu-el'}>
                    {navList
                        ? navList.map((item, index) => {
                            if (parseInt(item.navigation_id, 10) === 6) {
                                return;
                            }
                            return <li className={navIndex[index] ? 'on' : ''} key={index}>
                                <div
                                    className={'just-bet'}
                                    style={{paddingLeft: '.4rem'}}
                                    onClick={() => {
                                        navIndex[index] = !navIndex[index];
                                        this.setState({
                                            navIndex: navIndex,
                                            navIndex2: navIndex[index] ? navIndex2 : []
                                        });
                                    }}
                                >
                                    <span>{item.navigation_name}</span>
                                    <span className={'menu-el-icon'}></span>
                                </div>
                                <ul>
                                    {item.child.length
                                        ? item.child.map((item2, index2) => {
                                            return <li
                                                className={navIndex2[index2] ? 'on' : ''}
                                                key={index2}
                                            >
                                                {
                                                    item2.flag === 'page'
                                                        ? <a
                                                            href={`/m/product/${item2.alias}`}
                                                            className={
                                                                `menu-el-page ${
                                                                    item2.alias === productId.id ? 'on' : ''
                                                                }`
                                                            }
                                                            style={{paddingLeft: '.8rem'}}
                                                        >
                                                            {item2.navigation_name}
                                                        </a>
                                                        : ''
                                                }
                                                {
                                                    item2.flag === 'navigation'
                                                        ? <div
                                                            className={'just-bet'}
                                                            style={{paddingLeft: '.8rem'}}
                                                            onClick={() => {
                                                                navIndex2[index2] = !navIndex2[index2];
                                                                this.setState({
                                                                    navIndex2: navIndex2
                                                                });
                                                            }}
                                                        >
                                                            <span>{item2.navigation_name}</span>
                                                            <span className={'menu-el-icon'}></span>
                                                        </div>
                                                        : ''
                                                }
                                                {
                                                    item2.flag === 'navigation'
                                                        ? <ul>
                                                            {
                                                                item2.child.map((item3, index3) => {
                                                                    if (item3.navigation_name === '安全指数') {
                                                                        return null;
                                                                    }
                                                                    return <li
                                                                        key={index3}
                                                                    >
                                                                        <a
                                                                            href={`/m/product/${item3.alias}`}
                                                                            style={{paddingLeft: '1.2rem'}}
                                                                            className={`menu-el-page ${
                                                                                item3.alias === productId.id
                                                                                    ? 'on'
                                                                                    : ''}`
                                                                            }
                                                                        >
                                                                            {item3.navigation_name}
                                                                        </a>
                                                                    </li>;
                                                                })
                                                            }
                                                        </ul>
                                                        : ''
                                                }
                                            </li>;
                                        })
                                        : ''
                                    }
                                </ul>
                            </li>;
                        })
                        : ''
                    }
                    {/* <li className={'extra-el'}>
                        <a href="/m/help">
                            帮助与支持
                        </a>
                    </li> */}
                    <li className={(extraIndex.indexOf(SAFE_ADVISORY) > -1 ? 'on' : '')}>
                        <div
                            className="just-bet"
                            onClick={() => {
                                const cur = extraIndex.slice(0);
                                const index = extraIndex.indexOf(SAFE_ADVISORY);
                                if (index > -1) {
                                    cur.splice(index, 1);
                                }
                                else {
                                    cur.push(SAFE_ADVISORY);
                                }
                                this.setState({extraIndex: cur});
                            }}
                            style={{paddingLeft: '.4rem'}}>
                            <span>安全资讯</span>
                            <span className={'menu-el-icon'}></span>
                        </div>
                        <ul>
                            <li className={'extra-el'}>
                                <a href="/m/forum">
                                    安全社区
                                </a>
                            </li>
                            <li className={'extra-el'}>
                                <a
                                    href="/m/bug_search"
                                    className={location.href.match('bug_search') ? 'on' : ''}
                                >
                                    漏洞库
                                </a>
                            </li>
                        </ul>
                    </li>

                    <li className={'extra-el'}>
                        <a
                            href="/m/about"
                            className={location.href.match('about') ? 'on' : ''}
                        >
                            关于我们
                        </a>
                    </li>
                </ul>
            </div>
        );

        return (
            <div className={'nav-bar'}>
                <div className={userShow ? 'single-menu-active' : ''}>
                    <NavBar
                        className="single-top-nav-bar"
                        mode="light"
                        icon={
                            <a className={'spu-logo'} href={'/m/'}>
                                <img src={require('../../asset/svg/spu_logo.svg')} alt={'spu-logo'} />
                            </a>
                        }
                        rightContent={
                            userShow || menuShow
                                ? <img
                                    className={'spu-nav-close'}
                                    key={2}
                                    src={require('../../asset/svg/menu-close.svg')}
                                    alt={'spu-menu'}
                                    onClick={() => {
                                        this.setState({
                                            userShow: false,
                                            menuShow: false
                                        });
                                    }}
                                />
                                : [
                                    <img
                                        className={'spu-account'}
                                        key={0}
                                        src={require('../../asset/svg/spu_menu_account.svg')}
                                        alt={'spu-account'}
                                        onClick={() => {
                                            this.setState({
                                                userShow: !this.state.userShow
                                            });
                                        }}
                                    />,
                                    <img
                                        className={'spu-menu'}
                                        key={1}
                                        src={require('../../asset/svg/spu_menu.svg')}
                                        alt={'spu-menu'}
                                        onClick={() => {
                                            this.setState({
                                                menuShow: !this.state.menuShow
                                            });
                                        }}
                                    />
                                ]
                        }
                    >
                    </NavBar>
                    {userShow ? userEl : null}
                    {menuShow ? menuEl : null}
                    {userShow || menuShow ? <div className="menu-mask" onClick={this.onMaskClick} /> : null}
                </div>
            </div>
        );
    }
}

export default withRouter(TopBar);



// WEBPACK FOOTER //
// ./src/components/NavBar/index.js